import React from 'react';

import moment from 'moment';
import {documentService} from '../../../store/services';
import FileListWindow from "../components/FileListWindow";
import {DOCUMENT_VIEWER_MODES} from "../../../constants/DOCUMENT_VIEWER_MODES";
import {documentActions} from "../../../store/actions";

const SelectDocumentToShare = (props) => {
  const {
    subTitle,
    sharedUserGuid,
    sharedUserName,
    memberGuid,
    userName
  } = props.location;

  let title = userName + "'s Virtual Data Room"
  if (userName.toLowerCase() === "your") {
    title = userName + " Virtual Data Room";
  } else {
    if (userName.toLowerCase().endsWith('s')) {
      title = userName + "' Virtual Data Room";
    }
  }

  return (<FileListWindow
    title={title}
    subtitle={subTitle + sharedUserName}
    includeSectionFilter
    includeCompanyFilter
    includeClassificationFilter
    includeCategoryFilter
    includeBeginDate
    initialSection={'All Sections'}
    initialBeginDate={new moment().subtract(90, 'days')}
    includeEndDate
    initialEndDate={new moment()}
    includeFilename
    sharedUser={true}
    sharedUserGuid={sharedUserGuid}
    userGuid={memberGuid}
    viewer={DOCUMENT_VIEWER_MODES.SELECT}
    getDocumentFromDocumentServiceMethod={(id) => documentService.getDocumentById(id)}
    searchDocumentFromDocumentServiceMethod={(searchFields) => documentActions.searchDocuments(searchFields)}
  />);
}

export default SelectDocumentToShare;
